import * as React from 'react';
import * as Redux from 'redux';
import qs from "query-string";
import { MainState } from '../../Core/reducers';
import { CoughSessionsListTable } from './CoughSessionsListTable';
import DocumentTitle from '../../misc/components/DocumentTitle';
import { Filter, ODataParams, Query, useQuery } from '../../Components/Query';
import { WebPortalClient } from 'webportalclient';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { Route, Switch, useLocation } from 'react-router-dom';
import LoadingWithMessage from '../../misc/components/LoadingWithMessage';
import { CoughAnalysisScreen } from '../../cough-analysis/components/CoughAnalysisScreen';
import { AnalyseAppProvider } from '../analyse';
import { useWebPortalApiClient } from '../../misc/api/WebPortalTokenClient';

export interface CoughSessionsListScreenProps {
    dispatch?: Redux.Dispatch<MainState>;
}

export const CoughSessionsListScreen = (props: CoughSessionsListScreenProps) => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();
    const location = useLocation();
    const [initialFilters, setInitialFilters] = React.useState<Filter[]>(undefined);
    const [initialAnalysisFilters, setInitialAnalysisFilters] = React.useState<Filter[]>(undefined);

    React.useEffect(() => {
        const queryString = qs.parse(location.search);

        if (queryString.statusId) {
                setInitialFilters([
                    {
                        field: "status",
                        condition: "eq",
                        values: [queryString.statusId],
                    }
                ]);
        } else {
            setInitialFilters([]);
        }
    }, [location.search]);

    const handleRefresh = async (params: ODataParams) => {
        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getCoughSessions("visit,analysisSets,id,name,serialNumber,deviceType,recordingStart,lastReceived,lastAnalysed,status,suppressed,postalTrackingNumber,postalReceived,configured",
            filter,
            params.orderby,
            'visit($expand=subject($expand=site($select=id,number))),analysisSets($select=id,status,statusName,typeName,created)',
            params.top,
            params.skip,
            undefined,
            true
        );
    }

    const coughAnalysisScreen = () => {
        return (<> <CoughAnalysisScreen filters={initialAnalysisFilters} onFiltersApplied={setInitialAnalysisFilters} /></>);
    }

    if (!initialFilters)
        return <LoadingWithMessage message="Loading Cough Sessions..." />

    return (
        <Switch>
            <Route path="/Cough" exact>
                <DocumentTitle title="Cough Sessions | Vitalograph Web Portal">
                    <Query initialFilters={initialFilters} initialOrdering={[{ field: "recordingStart", condition: "asc" }]} onRefresh={handleRefresh}>
                        <CoughSessionsListTable />
                    </Query>
                </DocumentTitle>
            </Route>
            <Route path="/Cough/Analysis" exact>
                {coughAnalysisScreen}
            </Route>
            <Route path="/Cough/Analyse/:primarySetId/:isViewOnly?" component={AnalyseAppProvider} />
        </Switch>
    );
};
